import { render, staticRenderFns } from "./PayGoldEspera.vue?vue&type=template&id=c298cf26&"
import script from "./PayGoldEspera.vue?vue&type=script&lang=js&"
export * from "./PayGoldEspera.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports